import { useTheme } from 'styled-components';
import { TagButton } from '../../Components/Common/TagButton';
import { SOMETHING_WRONG } from '../../Components/Common/app.constants';
import { formatDateTimeWithTimeZone } from './dateUtils';
import React from 'react';
import { useSettingsContext } from './SettingsContext';
import {
  getRelationFilter,
  getRelationWidgetConfig
} from '../APIClient/relatedInstance';
import { isEmpty } from 'lodash';
import { differenceInDays } from 'date-fns';

export const getErrorMessage = response => {
  if (response?.response?.data) {
    if (typeof response.response.data === 'object') {
      return response.response.data.message;
    } else if (typeof response.response.data === 'string') {
      return response.response.data;
    }
  } else if (response && typeof response === 'object') {
    return response.message;
  }
  return SOMETHING_WRONG;
};

export const checkIsNewlyCreated = (
  dateValue,
  settings,
  daysDifferenceCount = 7
) => {
  const { timeFormat, dateFormat, timeZone } = settings.dateTimeFormat;
  const todaysDateString = new Date();
  const todaysDate = new Date(
    formatDateTimeWithTimeZone(
      todaysDateString,
      timeFormat,
      dateFormat,
      timeZone
    )
  );

  const createdDate = new Date(
    formatDateTimeWithTimeZone(dateValue, timeFormat, dateFormat, timeZone)
  );

  const daysDifference =
    (todaysDate.getTime() - createdDate.getTime()) / (1000 * 3600 * 24);

  if (Math.ceil(daysDifference) <= daysDifferenceCount) {
    return true;
  }
  return false;
};

export const getDaysDifference = (startDateValue, endDateValue) => {
  const endDate = new Date(endDateValue);
  const daysDifference = differenceInDays(endDate, startDateValue);
  return Math.ceil(daysDifference);
};

export const isAuditLogMatched = (auditLogData, instanceId) => {
  const surveyId = auditLogData.attributes.find(
    item => item.name === 'EntityId'
  );
  if (surveyId && surveyId.textValue === instanceId) {
    return true;
  }
  return false;
};

export const GetDaysLeftTag = ({ instance, attributeName, style }) => {
  const theme = useTheme();
  const { settings } = useSettingsContext();
  const startDateString = new Date();
  const endDateString = instance.attributes.find(
    item => item.name === attributeName
  );
  if (endDateString && endDateString.dateValue) {
    const daysDifference = getDaysDifference(
      startDateString,
      endDateString.dateValue,
      settings
    );
    const tagText =
      daysDifference === 0 ? 'Last day' : daysDifference + ' days left';
    let colour = null;
    let backgroundColour = null;
    if (daysDifference <= 2) {
      colour = theme.palette.customColors.darkRed;
      backgroundColour = theme.palette.customColors.lightRed;
    } else {
      colour = theme.palette.secondary.main;
      backgroundColour = theme.palette.customColors.lightOrange;
    }
    return (
      <TagButton
        text={tagText}
        style={{
          color: colour,
          backgroundColor: backgroundColour,
          ...style
        }}
      />
    );
  }
  return null;
};

export function checkIsAdminRoleUser(userData) {
  const adminRoles = ['Coco Admin', 'Community Admin'];
  if (
    userData.roles.length > 0 &&
    adminRoles.find(item => userData.roles.toString().includes(item))
  ) {
    return true;
  }
  return false;
}

export function checkIsViewerRoleUser(userData) {
  const adminRoles = ['Viewer'];
  if (
    userData.roles.length > 0 &&
    adminRoles.find(item => userData.roles.toString().includes(item))
  ) {
    return true;
  }
  return false;
}
export const getRelationFilterByRelatedTypeName = (
  viewConfig,
  relatedTypeName
) => {
  const widgetData = viewConfig.widgets.find(
    item => item.relatedTypeName === relatedTypeName
  );
  let widgetConfig = getRelationWidgetConfig(widgetData);
  const surveyRelationFilter = getRelationFilter(widgetConfig.relationFilters);
  return surveyRelationFilter;
};

export function getAttributeFilter(entityType, userData) {
  return [
    {
      operator: 'And',
      attributeFilterConditions: [
        {
          attributeName: 'EntityType',
          condition: 'Equals',
          firstValue: entityType,
          operator: 'None'
        }
      ]
    },
    {
      operator: 'And',
      attributeFilterConditions: [
        {
          attributeName: 'ActivityCreator',
          condition: 'Equals',
          firstValue: userData.userId,
          operator: 'None'
        }
      ]
    }
  ];
}

export const hasErrorsInForm = errors => {
  let hasError = false;
  if (errors && typeof errors === 'object' && !isEmpty(errors)) {
    for (let key in errors) {
      if (errors[key] !== '') {
        hasError = true;
      }
    }
  }
  return hasError;
};

export const htmlSubString = (htmlString, length) => {
  var matchingString,
    regexToGetTags = /<([^>\s]*)[^>]*>/g,
    stack = [],
    lastIndex = 0,
    result = '';

  //for each tag, while we don't have enough characters
  while ((matchingString = regexToGetTags.exec(htmlString)) && length) {
    //get the text substring between the last tag and this one
    var temp = htmlString
      .substring(lastIndex, matchingString.index)
      .substr(0, length);
    //append to the result and count the number of characters added
    result += temp;
    length -= temp.length;
    lastIndex = regexToGetTags.lastIndex;

    if (length) {
      result += matchingString[0];
      if (matchingString[1].indexOf('/') === 0) {
        //if this is a closing tag, than pop the stack (does not account for bad html)
        stack.pop();
      } else if (
        matchingString[1].lastIndexOf('/') !==
        matchingString[1].length - 1
      ) {
        //if this is not a self closing tag than push it in the stack
        stack.push(matchingString[1]);
      }
    }
  }

  //add the remainder of the string, if needed (there are no more tags in here)
  result += htmlString.substr(lastIndex, length);

  //fix the unclosed tags
  while (stack.length) {
    result += '</' + stack.pop() + '>';
  }

  return result;
};
